import React from 'react';
import { XCircle, AlertCircle, CheckCircle, Zap } from 'lucide-react';

const difficultyConfig = {
    again: {
        icon: XCircle,
        label: 'Nochmal',
        color: 'red',
        gradient: 'from-red-500/10 to-red-600/5',
        border: 'border-red-500/30',
        text: 'text-red-400',
        glow: 'shadow-red-500/10',
    },
    hard: {
        icon: AlertCircle,
        label: 'Schwer',
        color: 'amber',
        gradient: 'from-amber-500/10 to-amber-600/5',
        border: 'border-amber-500/30',
        text: 'text-amber-400',
        glow: 'shadow-amber-500/10',
    },
    good: {
        icon: CheckCircle,
        label: 'Gut',
        color: 'green',
        gradient: 'from-plantlix-500/10 to-plantlix-600/5',
        border: 'border-plantlix-500/30',
        text: 'text-plantlix-400',
        glow: 'shadow-plantlix-500/10',
    },
    easy: {
        icon: Zap,
        label: 'Einfach',
        color: 'blue',
        gradient: 'from-blue-500/10 to-blue-600/5',
        border: 'border-blue-500/30',
        text: 'text-blue-400',
        glow: 'shadow-blue-500/10',
    },
};

export default function DifficultyButtons({ onSelect, disabled = false, compact = false }) {
    return (
        <div className={`grid grid-cols-2 sm:grid-cols-4 gap-2 w-full ${compact ? 'max-w-xl' : 'max-w-2xl'} mx-auto`}>
            {Object.entries(difficultyConfig).map(([key, config]) => {
                const Icon = config.icon;
                return (
                    <button
                        key={key}
                        onClick={(e) => {
                            e.stopPropagation();
                            onSelect(key);
                        }}
                        disabled={disabled}
                        className={`
                            group relative flex flex-col items-center justify-center
                            ${compact ? 'py-2 px-1' : 'py-3 sm:py-4 px-2'} 
                            rounded-2xl border transition-all duration-300
                            bg-gradient-to-br ${config.gradient} ${config.border}
                            backdrop-blur-md shadow-lg ${config.glow}
                            hover:scale-[1.03] hover:border-white/40
                            active:scale-95 disabled:opacity-40 disabled:scale-100 disabled:cursor-not-allowed
                        `}
                    >
                        <div className={`
                            ${compact ? 'p-1.5' : 'p-2 sm:p-2.5'} 
                            rounded-full bg-black/20 mb-1 sm:mb-2 
                            group-hover:bg-white/10 transition-colors
                        `}>
                            <Icon className={`${compact ? 'w-4 h-4' : 'w-5 h-5 sm:w-6 sm:h-6'} ${config.text}`} />
                        </div>
                        <span className={`
                            ${compact ? 'text-[10px]' : 'text-xs sm:text-sm'} 
                            font-black uppercase tracking-widest ${config.text}
                        `}>
                            {config.label}
                        </span>

                        {/* Interactive glow effect */}
                        <div className="absolute inset-0 rounded-2xl bg-white/5 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
                    </button>
                );
            })}
        </div>
    );
}
